export function iterateQuerySelectorAll(root: HTMLElement, selector: string, cb: (value: never, index: number, array: never[]) => void)
{
    [].forEach.call(root.querySelectorAll(selector), cb);
}

export function getMatched(element: HTMLElement, selector: string)
{
    if(element.matches(selector)) {
        return element;
    }

    let parent = element.parentElement;

    while(parent !== null && !parent.matches(selector)) {
        parent = parent.parentElement;
    }

    return parent;
}

export function addClass(el: HTMLElement, cls: string)
{
    if(!el.classList.contains(cls)) {
        el.classList.add(cls);
    }
}

export function removeClass(el: HTMLElement, cls: string)
{
    el.classList.remove(cls);
}

export function findParentBySelector(element: HTMLElement, selector: string)
{
    let current = element.parentElement;

    while(current && ! current.matches(selector)) {
        current = current.parentElement;
    }

    return current;
}
